import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel.tsx";
import { useGetAangevraagdeLandelijkeFaciliteiten } from "@/entities/vestiging";
import { RoleGate, UserRole } from "@/features/auth";
import { ErrorDisplay, Skeleton } from "@/shared/components";
import { useArchiveVisibility } from "@/shared/hooks";
import { useParams } from "react-router";
import { LandelijkeFaciliteitenKlantenservice } from "../../klantenservice";
import { LandelijkeFaciliteitenRegievoerder } from "../../regievoerder";
import { LandelijkeFaciliteitenReadOnly } from "./landelijke-faciliteiten-readonly";

export function LandelijkeFaciliteitenDetails() {
    const { id } = useParams() as { id: string };
    const isArchived = useArchiveVisibility();
    const { data: aanvraag, isPending, error } = useGetAangevraagdeLandelijkeFaciliteiten(id);

    if (isPending) {
        return (
            <DossierDetailsPanel testId="landelijke-faciliteiten-skeleton">
                <DossierDetailsHeader section="FaciliteitenLandelijk" showBackButton />
                <DossierDetailsContent className="grid grid-cols-1 gap-y-6">
                    <div className="grid grid-cols-1 gap-y-2 pt-4">
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-3/4" />
                        <Skeleton className="h-4 w-3/4" />
                    </div>
                    <Skeleton className="h-10 w-full" />
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    if (error) {
        return (
            <DossierDetailsPanel testId="landelijke-faciliteiten-error">
                <DossierDetailsHeader section="FaciliteitenLandelijk" showBackButton />
                <DossierDetailsContent>
                    <ErrorDisplay
                        error={error}
                        variant="section"
                        title="Fout bij het laden van landelijke faciliteiten"
                        onRetry={() => window.location.reload()}
                    />
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="FaciliteitenLandelijk" showBackButton />
            <DossierDetailsContent className="space-y-6">
                {isArchived ? (
                    <LandelijkeFaciliteitenReadOnly aanvraag={aanvraag} />
                ) : (
                    <>
                        <RoleGate roles={[UserRole.REGIEVOERDER]}>
                            <LandelijkeFaciliteitenRegievoerder dossierId={id} aanvraag={aanvraag} />
                        </RoleGate>
                        <RoleGate roles={[UserRole.KLANTENSERVICE]}>
                            <LandelijkeFaciliteitenKlantenservice dossierId={id} aanvraag={aanvraag} />
                        </RoleGate>
                        <RoleGate roles={[UserRole.SUPPORTCONSULTANT, UserRole.ALLEENLEZEN]}>
                            <LandelijkeFaciliteitenReadOnly aanvraag={aanvraag} />
                        </RoleGate>
                    </>
                )}
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
